import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";

const fieldsConfig = {
    'projects': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'tasksByTitle': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },
    'tasksByShortId': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'documents': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },

    'users': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },

    'modules': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    },

    'tasksClosed': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : false,
    }
}

// const debug = 'UserSettings_QuickSearch'
const debug = false

export default class UserSettings_QuickSearch extends ServerSettings {

    public projects             : boolean = true
    public tasksByTitle         : boolean = true
    public tasksByShortId       : boolean = true
    public documents            : boolean = true
    public users                : boolean = false
    public modules              : boolean = false
    public tasksClosed          : boolean = false

    constructor(config: JSONObject) {
        super(config, fieldsConfig)

        debug && console.log(debug, 'constructor', config)

        this.projects           = this.initValue('projects')
        this.tasksByTitle       = this.initValue('tasksByTitle')
        this.tasksByShortId     = this.initValue('tasksByShortId')
        this.documents          = this.initValue('documents')
        this.users              = this.initValue('users')
        this.modules            = this.initValue('modules')
        this.tasksClosed        = this.initValue('tasksClosed')
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'projects')
        this.valueToJson(result, 'tasksByTitle')
        this.valueToJson(result, 'tasksByShortId')
        this.valueToJson(result, 'tasksClosed')
        this.valueToJson(result, 'documents')
        this.valueToJson(result, 'users')
        this.valueToJson(result, 'modules')


        return result
    }
}
